import Home from './components/Home';
import NavBar from './components/NavBar';
import About from './components/About';
import SocialLinks from './components/SocialLinks';
import Portfolio from './components/Portfolio';
import Footer from './components/Footer';


function App() {
  return (
    <div>
      
      <NavBar/>
      <Home/>
      <About/>
      <Portfolio/>
      <SocialLinks/>
      <Footer/>
      
    </div>
  );
}

export default App;
